import { Pipe, PipeTransform } from '@angular/core';
import { get as _get, isArray as _isArray, isString as _isString, castArray} from 'lodash-es'
@Pipe({
  name: 'jsonParse'
})
export class JsonParsePipe implements PipeTransform {

  transform(value: string, pathToAccess: string): any {
    try {
      const parsed = JSON.parse(value) ;
      if (pathToAccess && parsed) {
        // Use lodash.get to safely access the nested property
        return _get(parsed, pathToAccess);
      }
      return parsed;
    } catch (e) {
      const parsed = (_isString(value) || _isArray(value)) && castArray(value)
      if (parsed) {
        return parsed
      }
      return null; // or the original value, depending on error handling preference
    }
  }

}
